import React from 'react';
import { Input, Box, Text } from '@chakra-ui/react';

const TokenInput = ({ value, onChange, label, error, placeholder }) => {
  const handleChange = (e) => {
    const val = e.target.value.replace(/\D/g, '');
    if (val.length <= 6) {
      onChange(val);
    }
  };

  return (
    <Box>
      {label && (
        <Text fontSize="14px" fontFamily="medium" color="#444" mb="0.5rem">
          {label}
        </Text>
      )}
      <Input
        value={value}
        onChange={handleChange}
        placeholder={placeholder || '000000'}
        maxLength={6}
        fontSize="24px"
        letterSpacing="0.5rem"
        textAlign="center"
        fontFamily="bold"
        h="60px"
        borderColor={error ? '#E24D4D' : '#E0E0E0'}
        _hover={{ borderColor: error ? '#E24D4D' : '#BDBDBD' }}
        _focus={{
          borderColor: error ? '#E24D4D' : '#1A73E8',
          boxShadow: error ? '0 0 0 1px #E24D4D' : '0 0 0 1px #1A73E8',
        }}
      />
      {error && (
        <Text color="#E24D4D" fontSize="12px" mt="0.5rem">
          {error}
        </Text>
      )}
    </Box>
  );
};

export { TokenInput };
